
import { useEffect, useRef } from 'react';

/**
 * Hook that alerts clicks outside of the passed ref
 */

function useClickOutside(ref, handler, enabled = true) {
  const handlerRef = useRef(handler);

  useEffect(() => {
    handlerRef.current = handler;
  }, [handler]);

  useEffect(() => {
    if (!enabled || !handler) {
      return;
    }
    const listener = (event) => {
      if (!ref.current || ref.current.contains(event.target)) {
        return;
      }
      // Don't close if clicking on a message reaction element
      // This prevents the flash when clicking reactions while the panel is open
      if (event.target.closest('.message-reactions')) {
        return;
      }
      handlerRef.current(event);
    };
    document.addEventListener('mousedown', listener);
    document.addEventListener('touchstart', listener);
    return () => {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    };
  }, [ref, enabled, handler]);
}

export default useClickOutside;
